import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/de";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { initGA } from "./analytics/ga";
import {
  basenameForWorkspace,
  resolveWorkspace,
  WorkspaceProvider,
} from "./utils/WorkspaceContext";

// Initialize Google Analytics with the tracking ID from environment variables
initGA();

// Every URL the app serves must live under a workspace prefix (/swageazy/*
// or /swayy/*) so BrowserRouter's basename can scope routing per project.
// Anything else (bare "/", password-reset links, OAuth callbacks minted by
// the backend without a prefix) gets redirected here, before React mounts,
// straight into the right workspace with its path/query preserved.
const activeWorkspace = resolveWorkspace(window.location.pathname);
const basename = basenameForWorkspace(activeWorkspace);

if (
  window.location.pathname !== basename &&
  !window.location.pathname.startsWith(`${basename}/`)
) {
  window.location.replace(
    `${basename}${window.location.pathname}${window.location.search}${window.location.hash}`,
  );
} else {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
  );
  root.render(
    <BrowserRouter basename={basename}>
      <WorkspaceProvider value={activeWorkspace}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
          <App />
        </LocalizationProvider>
      </WorkspaceProvider>
    </BrowserRouter>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
